import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import Login from "@/views/Login.vue";
import ItemList from '@/views/ItemList.vue';
import ItemPerfect from "@/views/ItemPerfect.vue";
import SpuList from "@/views/SpuList.vue";
import SpuModify from "@/views/SpuModify.vue";
import OrderParse from "@/views/OrderParse.vue";
import TaskList from "@/views/TaskList.vue";
import ATMTaskList from "@/views/ATMTaskList.vue";
import ATMItemPerfect from "@/views/ATMItemPerfect.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/item/list',
    name: 'ItemList',
    component: ItemList,
  },
  {
    path: '/item/perfect/:itemId/:taskId',
    name: 'ItemPerfect',
    component: ItemPerfect,
  },
  {
    path: '/item/perfect/:itemId',
    name: 'ItemPerfect',
    component: ItemPerfect,
  },
  {
    path: '/spu/list',
    name: 'SpuList',
    component: SpuList,
  },
  {
    path: '/spu/modify/:id',
    name: 'SpuModify',
    component: SpuModify,
  },
  {
    path: '/spu/add',
    name: 'SpuModify',
    component: SpuModify,
  },
  {
    path: '/order/parse',
    name: 'OrderParse',
    component: OrderParse,
  },
  {
    path: '/task/list',
    name: 'TaskList',
    component: TaskList,
  },
  {
    path: '/atm/task/list',
    name: 'ATMTaskList',
    component: ATMTaskList,
  },
  {
    path: '/atm/item/perfect/:itemId/:taskId',
    name: 'ATMItemPerfect',
    component: ATMItemPerfect,
  },
  {
    path: '/atm/item/perfect/:itemId',
    name: 'ATMItemPerfect',
    component: ATMItemPerfect,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
